import url from './url';

async function handleMaterias() {

    let data = await fetch(`${url}/materia`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        method: 'get'
    }).then(res => res.json());

    return data;

}

async function getMateria(token, id) {

    let data = await fetch(`${url}/materia/${id}`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'get'
    }).then(res => res.json());

    return data;

}

export { handleMaterias, getMateria }